import { yupResolver } from "@hookform/resolvers/yup";
import { useEffect, useState } from "react";

import ReactFlagsSelect from "react-flags-select";
import { useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { Link, useNavigate } from "react-router-dom";
import loginApi from "../../api/LoginApi";
import { interfaceLoginState } from "../../interface/LoginInterface";
import { countries, customLabels, dialcodes } from "../../utils/countries";
import Konsole from "../../utils/konsole/Konsole";
import GlobalButton from "../Buttons/btn2/GlobalButton";
import InputMobileNumber from "../FormFields/InputMobileNumber";
import { initialLoginState, loginSchema } from "./LoginValidation";
// import LabelText from "../FormLabels/LabelText";

export default function LoginView() {
  const { t } = useTranslation();
  const [selectedPhoneCode, setSelectedPhoneCode] = useState("IN");
  const [isTandC, setIsTandC] = useState(true);
  const [isErrorShow, setIsErrorShow] = useState(false)

  const {
    handleSubmit,
    formState: { errors },
    register,
  } = useForm({
    resolver: yupResolver(loginSchema),
    defaultValues: initialLoginState,
  });
  const [loading, setLoading] = useState(false);
  Konsole.log("loading", loading);
  const navigate = useNavigate();
  const onSubmitHandler = async (state: interfaceLoginState) => {

    if (isTandC == false) {
      setIsErrorShow(true)
      return false;
    }
    setLoading(true);
    const data = {
      ...state,
      phone_code: dialcodes.filter((obj: any) => {
        return obj.isoCode === selectedPhoneCode;
      })[0]?.dialCode,
      // phone_code: selectedPhoneCode,
    };
    setLoading(await loginApi(data, navigate));
  };

  // @@  this use effect is for removing scroll body from ios
  useEffect(() => {
    const urlPath = window.location.pathname
    if (urlPath == '/login') {
      document.body.classList.add('login_otp_overflow');
    }

    return () => {
      document.body.classList.remove('login_otp_overflow');
    }
  }, []);

  return (
    <>
      <div className="md:p-20">
        <div className="store-card menu max-w-[26rem]  m-auto h-screen md:h-auto">
          <Link to="/menu" className="px-2 block md:hidden">
            <img src="/images/back-icon.svg" />
          </Link>
          <div className="p-2">
            <h1 className="font-normal text-2xl font-splekta mb-3">
              {t("Login.whatsYourPhoneNumber")}
            </h1>
            <p className="text-[#606060] textMd font-normal mb-6">
              {t("Login.loginCreateAnAccountForFOE")}
            </p>
            <form onSubmit={handleSubmit(onSubmitHandler)}>
              <div className="formItem">
                <div className="flex gap-2 items-center tap-inter-num">
                  <ReactFlagsSelect
                    selected={selectedPhoneCode}
                    onSelect={(code: any) => setSelectedPhoneCode(code)}
                    searchable={false}
                    fullWidth={false}
                    // countries={countries?.filter((i)=>i=='IN')}

                    countries={['IN']}
                    
                    // customLabels={customLabels}
                     customLabels={{ IN: '+91' }}
                     
                    // showSelectedLabel={false}
                    showSelectedLabel={true}
                    showSecondarySelectedLabel={false}
                    placeholder={+91}
                    
                    className="px-3  border !border-[#D2D2D2] !rounded-lg padding-top-bottom h-[3.625rem]"
                    selectButtonClassName="selected-input selected-country-code-eent-not-clickable"
                    selectedSize={14}
                    optionsSize={14}
                  />
                  {/* {/ <input placeholder="Enter Phone Number"/> /} */}
                  <div className="w-full">
                    <InputMobileNumber
                      placeholder={t("Login.enterPhoneNumber")}
                      name="mobileNumber"
                      register={register}
                    ></InputMobileNumber>
                    <div className="errorFields">
                      {errors.mobileNumber?.message
                        ? t(errors.mobileNumber?.message)
                        : ""}
                    </div>
                  </div>
                </div>
              </div>
              <GlobalButton label={t("VerifyOtp.continue")}  type="submit" loading={loading} />
            </form>
            <div className="mt-5 mb-4 flex gap-2">
              <input checked={isTandC} onChange={(e: any) => { setIsErrorShow(false); setIsTandC(e.target.checked) }} type="checkbox" className="!block pt-1 accent-black shrink-0 login-margin" style={{ height: "0.9rem", width: "0.9rem" }} />
              <p className="textMd ubermoveTextNormal">
                {t("Login.byClickingAccept")}{" "}
                <Link to="" className="underline">
                  {t("Login.termOfService")}
                </Link>{" "}
                {t("Login.and")}{" "}
                <Link to="" className="underline">
                  {t("Login.privatePolicy")}
                </Link>
              </p>
            </div>
            {(isTandC == false && isErrorShow) ?
              <div style={{ fontSize: '.75rem' }} className="text-red-500 -bottom-5 right-0 font-semibold">{t("Login.pleaseCheckTermAndConditions")}</div>
              : null}
          </div>
        </div>
      </div>
    </>
  );
}
